// Programmatic counterpart to the Sass palette in _settings.colors.scss.
// Prefer Sass variables in component styles; use these values only where a
// color must be passed to JavaScript-driven UI such as spreadsheet rendering.
export enum ThemeColors {
    Primary = '#315ca8',
    PrimaryHover = '#4f75b5',
    PrimaryActive = '#153a85',
    PrimaryAccent = '#5a8fe8',
    PrimarySoft = '#eef3fb',
}
